// src/components/works/SystemDevelopmentContent.tsx
import React from 'react';
import {
  IntroText,
  SubHeading,
  ContentParagraph,
  EmphasisText,
  StyledList,
  StyledListItem,
  CallToActionText,
} from '../../styles/GlobalStyles';

const SystemDevelopmentContent: React.FC = () => {
  return (
    <>
      <IntroText>
        お客様のビジネスを加速させる、オーダーメイドのITソリューションを。
      </IntroText>
      <ContentParagraph>
        企業様の課題：業務フローの非効率、新規サービス立ち上げの遅延、DX推進の不明確さ...
      </ContentParagraph>
      <ContentParagraph>
        Ludyworksは、お客様の課題を深く理解し、ビジネス価値を最大化するシステムを構築します。
        最適な技術とアジャイル開発で、お客様のアイデアを形にし、ビジネス成長を支援します。
      </ContentParagraph>

      <SubHeading>提供サービス</SubHeading>
      <StyledList>
        <StyledListItem>
          <EmphasisText>Webシステム開発：</EmphasisText>
          CRM、SFA、在庫管理、ECサイト、マッチングプラットフォーム、SaaS、API
        </StyledListItem>
        <StyledListItem>
          <EmphasisText>モバイルアプリ開発：</EmphasisText>
          iOS/Android、React Native, Flutter、PWA
        </StyledListItem>
        <StyledListItem>
          <EmphasisText>クラウドソリューション：</EmphasisText>
          AWS, Azure, GCP、サーバーレス、データ分析基盤、DevOps
        </StyledListItem>
        <StyledListItem>
          <EmphasisText>DXコンサル＆PoC：</EmphasisText>
          業務分析、DX戦略、PoC開発
        </StyledListItem>
        <StyledListItem>
          <EmphasisText>AI・データ活用：</EmphasisText>
          機械学習、データ分析・可視化、チャットボット
        </StyledListItem>
      </StyledList>

      <SubHeading>開発プロセスの特徴</SubHeading>
      <StyledList>
        <StyledListItem>
          <EmphasisText>共創：</EmphasisText>
          ビジネスモデルから将来の展望まで深く理解し、共に最適なソリューションを創出。
        </StyledListItem>
        <StyledListItem>
          <EmphasisText>アジャイル：</EmphasisText>
          変化に強いアジャイル開発で、迅速かつ継続的に価値を提供。
        </StyledListItem>
        <StyledListItem>
          <EmphasisText>最適な技術：</EmphasisText>
          React, TypeScript, Node.js, Python, Go、各種クラウドサービスを活用。
        </StyledListItem>
        <StyledListItem>
          <EmphasisText>品質：</EmphasisText>
          コードレビュー、テスト、CI/CDで高品質なシステムを実現。
        </StyledListItem>
        <StyledListItem>
          <EmphasisText>継続的サポート：</EmphasisText>
          保守運用から機能改善、グロースハックまで支援。
        </StyledListItem>
      </StyledList>

      <SubHeading>こんな企業に最適</SubHeading>
      <ContentParagraph>
        - スピーディーな新規事業立ち上げで競争優位性を確立したい企業
        - 既存業務のデジタル化・自動化で生産性向上とコスト削減を実現したい企業
        - 業界・業務特化の専用システムを求めている企業
        - DX推進のパートナーを探している企業
      </ContentParagraph>

      <CallToActionText>
        お客様の「こうしたい」を、確かな技術で実現します。まずはお気軽にご相談ください。
      </CallToActionText>
    </>
  );
};

export default SystemDevelopmentContent;
